import { FieldBase, IFieldOptions } from './field-base.interface'

export class NumberField extends FieldBase<number> {
  controlType = 'number'

  constructor(options: IFieldOptions<number> = {}) {
    super(options)
  }
}
